// extracted by mini-css-extract-plugin
module.exports = {"rc-tabs-bar":"gxB4z","rc-tabs-tab-active":"_8gT9e","input-suffix":"Qs1A+","nav-item":"wz+kb","input-container":"bMiuu","input":"bw+1V"};